//HOST
// const HOST = 'http://localhost:5000/api';
// export const HOST_URL = 'http://localhost:5000';
const HOST = 'https://thetconcept.azurewebsites.net/api';
export const HOST_URL = 'https://thetconcept.azurewebsites.net';

//DATABASE
export const PRODUCT_SERVER = `${HOST}/Products/get-products-by-category-name`;
export const PRODUCT_DETAIL_SERVER = `${HOST}/Products/get-product-by-id`;
export const PRODUCT_IMAGE_DETAIL_SERVER = `${HOST}/Products/get-product-image-detail`;
export const PRODUCT_RELATED_SERVER = `${HOST}/Products/get-all-products-related`;
export const LOGIN_USER_SERVER = `${HOST}/Customers/login`;
export const CREATE_ORDER_SERVER = `${HOST}/Orders/create-order`;
export const CREATE_CUSTOMER_ACCOUNT_SERVER = `${HOST}/Customers/create-customer`;
export const SEND_SMS_TO_CUSTOMER_SERVER = `${HOST}/Customers/send-sms-to-customer`;
export const ORDER_DETAILS_SERVER = `${HOST}/Orders/get-order-details-by-username`;
export const SEARCH_PRODUCTS_SERVER = `${HOST}/Products/search-products`;
export const GET_PRODUCTS_BEST_SELLER_SERVER = `${HOST}/Products/get-top-best-seller`;
export const GET_CUSTOMER_ACCOUNT_SERVER = `${HOST}/Customers/get-by-id`;
export const UPDATE_CUSTOMER_ACCOUNT_SERVER = `${HOST}/Customers/update-customer`;
export const GET_ORDER_DETAILS_BY_ORDERID_SERVER = `${HOST}/Orders/get-order-details-by-orderid`;
export const CHECK_STOCK_PRODUCT_SERVER = `${HOST}/Products/check-stock-product`;
export const GET_PRODUCTS_RATING_SERVER = `${HOST}/Products/get-products-rating`;
export const UPDATE_PRODUCTS_RATING_SERVER = `${HOST}/Products/update-products-rating`;
export const GET_PRODUCTS_INTEREST_SERVER = `${HOST}/Products/get-products-interest`;
export const PRODUCT_ALL_SERVER = `${HOST}/Products/get-all-products`;
export const UPDATE_PRODUCT_SERVER = `${HOST}/Products/update-product`;
export const CREATE_PRODUCT_SERVER = `${HOST}/Products/create-product`;
export const DELETE_PRODUCT_SERVER = `${HOST}/Products/delete-product-by-id`;
export const GET_PAYMENT_METHOD_SERVER = `${HOST}/Orders/get-payment-method`;
export const GET_PROVINCES_SERVER = `${HOST}/Customers/get-provinces`;
export const GET_DISTRICTS_SERVER = `${HOST}/Customers/get-districts`;
export const GET_WARDS_SERVER = `${HOST}/Customers/get-wards`;
export const GET_CATEGORIES_SERVER = `${HOST}/Categories/get-categories`;
export const GET_CATEGORIES_DATA_SERVER = `${HOST}/Categories/get-categories-data`;
export const PAYMENT_BY_MOMO_SERVER = `${HOST}/Orders/payment-by-momo`;
export const PAYMENT_BY_ZALO_PAY_SERVER = `${HOST}/Orders/payment-by-zalo-pay`;
export const GET_WISHLIST_SERVER = `${HOST}/Customers/get-wishlist`;
export const ADD_TO_WISHLIST_SERVER = `${HOST}/Customers/add-to-wishlist`;
export const GET_COMMENTS_SERVER = `${HOST}/Customers/get-comments`;
export const CREATE_COMMENT_SERVER = `${HOST}/Customers/create-comment`;
export const GET_TEMPLATES_SERVER = `${HOST}/Templates/get-templates`;